module.exports = __webpack_public_path__ + "img/wenjian.4923b6b7.png";